/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios';
import dayjs from 'dayjs';

import { miscActions } from 'features/Misc/miscSlice';
import { projectFilterActions } from 'features/Project/projectSlice';
import { worklogActions } from 'features/worklog/worklogSlice';
import {
  getBackendUrl,
  useGetActiveJobsQuery,
  useGetActivitiesQuery,
  useGetClientsQuery,
  useGetTaggingListWorklogsQuery,
  useGetTaxCodesQuery,
  useGetUserListQuery,
} from 'services/busmanApi';

import { RootState } from '../../store';

const GlobalFetchData = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const clientsResult = useGetClientsQuery({});
  const jobsResult = useGetActiveJobsQuery({});
  const activitiesResult = useGetActivitiesQuery({});
  const tagList = useGetTaggingListWorklogsQuery({});
  const userList = useGetUserListQuery({}, { skip: user.role !== 'E' });
  const taxCodes = useGetTaxCodesQuery({});

  // check public holiday data in localstorage
  const holidays = localStorage.getItem('public-holiday');

  // Fetch Client details
  React.useEffect(() => {
    if (!clientsResult.isLoading && !clientsResult.error && clientsResult.data) {
      dispatch(worklogActions.setClients(clientsResult.data));
    }
  }, [clientsResult]);

  // Fetch job details
  React.useEffect(() => {
    if (!jobsResult.isLoading && !jobsResult.error && jobsResult.data) {
      dispatch(worklogActions.setJobs(jobsResult.data));
    }
  }, [jobsResult]);

  React.useEffect(() => {
    if (!activitiesResult.isLoading && !activitiesResult.error && activitiesResult.data) {
      dispatch(worklogActions.setActivities(activitiesResult.data));
    }
  }, [activitiesResult]);

  React.useEffect(() => {
    if (!tagList.error && tagList.data) {
      dispatch(worklogActions.setTagList(tagList.data));
    }
  }, [tagList]);

  React.useEffect(() => {
    if (!userList.error && userList.data) {
      dispatch(projectFilterActions.setAssigneeList(userList.data));
    }
  }, [userList]);

  React.useEffect(() => {
    if (!taxCodes.error && taxCodes.data) {
      dispatch(miscActions.setTaxCodes(taxCodes.data));
    }
  });

  React.useEffect(() => {
    const url = getBackendUrl();
    const fetchHolidays = async () => {
      try {
        const response = await axios.get(url + '/user/holidays/');

        if (response.data) {
          const waHolidayRecords = response.data.data;
          localStorage.setItem('public-holiday', JSON.stringify(waHolidayRecords));
        }
      } catch (error) {
        // Handle errors
        console.error('Error fetching public holidays data');
      }
    };

    if (!holidays) {
      fetchHolidays();
      return;
    }

    const parsedHolidays = JSON.parse(holidays);
    const currentYear = dayjs().year();
    const holidaysYear = dayjs(parsedHolidays[0]).year();

    if (currentYear !== holidaysYear) {
      fetchHolidays();
    }
  }, []);
  return <React.Fragment></React.Fragment>;
};

export default GlobalFetchData;
